import React from "react"
import { TouchableOpacity, StyleSheet, Text, Image, View } from "react-native"
import { theme } from "@common/theme/theme"

/**
 * Chip d'options pour le funnel brevet.
 * Utilise <Text> RN natif (pas TextM) car certaines props flex de TextM cassent
 * la taille du chip sur react-native-web.
 *
 * `iconUri` (optionnel) : URL d'une petite icône affichée avant le label
 * (utilisé par le funnel été pour les icônes de matières). Rétro-compatible —
 * les usages brevet ne passent pas d'icône et restent inchangés.
 */
const BrevetChip = ({ label, selected, onPress, disabled, style, iconUri }) => {
    return (
        <TouchableOpacity
            onPress={disabled ? undefined : onPress}
            activeOpacity={0.7}
            style={[
                styles.chip,
                selected && styles.chipSelected,
                disabled && styles.chipDisabled,
                style,
            ]}
        >
            <View style={styles.row}>
                {iconUri ? (
                    <Image
                        source={{ uri: iconUri }}
                        style={styles.icon}
                        resizeMode="contain"
                    />
                ) : null}
                <Text
                    style={[
                        styles.label,
                        selected && styles.labelSelected,
                    ]}
                >
                    {label}
                </Text>
            </View>
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    chip: {
        paddingHorizontal: 14,
        paddingVertical: 9,
        borderRadius: 20,
        borderWidth: 1.5,
        borderColor: theme.colors.lightMore,
        backgroundColor: theme.colors.white,
    },
    chipSelected: {
        borderColor: theme.colors.primary,
        backgroundColor: theme.colors.primaryLighter,
    },
    chipDisabled: {
        opacity: 0.4,
    },
    row: {
        flexDirection: "row",
        alignItems: "center",
    },
    icon: {
        width: 18,
        height: 18,
        marginRight: 6,
    },
    label: {
        fontFamily: "Montserrat-Medium",
        fontSize: 13,
        color: theme.colors.grey,
    },
    labelSelected: {
        fontFamily: "Montserrat-Bold",
        color: theme.colors.primary,
    },
})

export default BrevetChip
